"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const React = __importStar(require("react"));
const color_tokens_1 = require("./theme/color-tokens");
const _1 = require(".");
const StyledIconButton = components_core_1.styled.button `
  align-content: center;
  background: none;
  border: none;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  outline: none;
  padding: 0;
  ${props => {
    const { button } = (0, color_tokens_1.getColorTokens)(props, _1.ButtonAppearance.Secondary);
    return `
      color: ${props.disabled
        ? button.disabled.color
        : button.default.color};
      height: ${props.theme.size.static500};
      width: ${props.theme.size.static500};
      :hover {
        color: ${props.disabled
        ? button.disabled.color
        : button.hover.color};
      }
      :focus {
        color: ${props.disabled
        ? button.disabled.color
        : button.active.color};
      border: 1px solid
        ${props.disabled
        ? 'transparent'
        : button.default.border};
    `;
}}
  }
`;
function IconButton({ ariaLabel, children, onClick, className, disabled, testId }) {
    return (React.createElement(StyledIconButton, { className: className, "aria-label": ariaLabel, onClick: onClick, disabled: disabled, "data-testid": testId }, children));
}
exports.IconButton = IconButton;
